import styled from "@emotion/styled";
import { fontIndivisibleVariable, fontRoboto, theme } from "@product/scmp-sdk";

import { BaseLink } from "shared/components/common/base-link";

import PostMagazineSvg from "./logo-post-magazine.svg";
import ScmpLogo from "./logo-scmp.svg";
import { PostMagazineSiteMap } from "./site-map";
import { PostMagazineSocialMedia } from "./social-media";

export const LogoStyleContainer = styled.div`
  grid-area: logo;

  max-inline-size: 295px;
`;

export const LogoContainer = styled(BaseLink)``;

export const LogoPostMagazine = styled(PostMagazineSvg)`
  inline-size: 160px;
  block-size: 38.846px;

  > path {
    fill: #ffffff;
  }
  ${theme.breakpoints.up("tablet")} {
    inline-size: 220px;
    block-size: 53.413px;
  }
`;

export const LogoCaption = styled.div`
  margin-block-start: 20px;

  color: #ffffff;
  font-weight: 300;
  font-size: 16px;
  font-family: ${fontIndivisibleVariable};
  text-transform: uppercase;
  font-variation-settings: "wght" 300;
`;

export const StyledPostMagazineSocialMedia = styled(PostMagazineSocialMedia)`
  grid-area: social;

  ${theme.breakpoints.up("tablet")} {
    inline-size: 116px;
  }
`;

export const SiteMapContainer = styled.div`
  grid-area: sitemap;

  display: flex;
  ${theme.breakpoints.up("tablet")} {
    justify-content: end;
  }
`;

export const StyledPostMagazineSiteMap = styled(PostMagazineSiteMap)``;

export const LogoSCMPContainer = styled(BaseLink)`
  grid-area: logo-scmp;
`;

export const Footer = styled.div`
  grid-area: foot;

  display: grid;
  grid-template-areas:
    "logo-scmp"
    "copyright";
  grid-row-gap: 24px;

  ${theme.breakpoints.up("tablet")} {
    grid: "logo-scmp copyright" / 1fr 1fr;
  }
`;

export const StyledScmpLogo = styled(ScmpLogo)``;

export const Copyright = styled.div`
  grid-area: copyright;

  color: #bbbbbb;
  font-weight: 400;
  font-size: 12px;
  font-family: ${fontRoboto};
  line-height: 120%;
  letter-spacing: -0.24px;

  ${theme.breakpoints.up("tablet")} {
    justify-self: end;

    font-size: 12px;
    text-align: end;
  }
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;

  padding-block: 48px;
  padding-inline: 40px;

  background: #333843;
`;

export const Wrapper = styled.div`
  display: grid;
  grid:
    "logo" min-content
    "." 40px
    "social" min-content
    "." 42px
    "sitemap" min-content
    "." 56px
    "foot" min-content/auto;

  inline-size: 100%;

  ${theme.breakpoints.up("tablet")} {
    grid:
      "logo sitemap" max-content
      ". sitemap" 10px
      "social sitemap" max-content
      ". ." 56px
      "foot foot" max-content/ auto auto;

    max-inline-size: 1200px;
  }
`;
